import Email from '../components/Email'
import MoveUpAnimation from '../components/MoveUpAnimation'
import PageBase from '../components/PageBase'
import { useAppT } from '../localization/config'

export default function PendulumPage() {
  const t = useAppT()

  return (
    <PageBase title={t.pendulum_title} subtitle={t.pendulum_subtitle} scroolToTop>
      <MoveUpAnimation>
        <img
          src="/assets/images/pendulum.webp"
          alt={t.pendulum_title}
          className="w-full max-w-sm mx-auto rounded-lg mt-4"
        />

        <h3 className="mt-8">🔮 {t.pendulum_benefits_title}</h3>
        <p>{t.pendulum_benefits_text}</p>
        <ul className="list-[circle] mt-4">
          <li>
            <strong>{t.pendulum_item_1_label}</strong> {t.pendulum_item_1_text}
          </li>
          <li>
            <strong>{t.pendulum_item_2_label}</strong> {t.pendulum_item_2_text}
          </li>
          <li>
            <strong>{t.pendulum_item_3_label}</strong> {t.pendulum_item_3_text}
          </li>
        </ul>

        <p className="mt-4">{t.pendulum_lessons_text}</p>

        <h3 className="mt-8">📩 {t.pendulum_contact_title}</h3>
        <Email shorten />

        <h3 className="mt-8">📍 {t.pendulum_where_title}</h3>
        <p>{t.pendulum_where_text}</p>
      </MoveUpAnimation>
    </PageBase>
  )
}
